// import Vue from "vue";
import { extend, localize, configure } from "vee-validate";
import ru from "vee-validate/dist/locale/ru.json";
import { required, email, min, confirmed } from "vee-validate/dist/rules";

extend("required", required);
extend("confirmed", confirmed);
extend("email", email);
extend("min", min);
extend("phone", {
	validate: (value) => {
		if (!value) return true;
		const regex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
		return Boolean(value.match(regex));
	},
});
extend("password", {
	params: ["target"],
	validate(value, { target }) {
		return value === target;
	},
	message: "Пароль должен быть одинаковый",
});

localize({
	ru: {
		messages: { ...ru.messages, confirmed: "Пароли не совпадают" },
		names: {
			email: "E-mail",
			password: "Пароль",
			confirmation: "Пароль (еще раз)",
			phone: "Телефон",
			agreementChecked: "Согласие",
		},
		fields: {
			password: {
				// min: "{_field_} должен состоять из {params} символов",
			},
			phone: {
				phone: "Поле {_field_} должно быть по шаблону",
			},
			agreementChecked: {
				required: "Обязательный флажок",
			},
		},
	},
});

configure({
	classes: {
		valid: "is-valid",
		invalid: "is-invalid",
	},
});

localize("ru");

// A simple get/set interface to manage our locale in components.
// This is not reactive, so don't create any computed properties/watchers off it.
// let LOCALE = "ru";
// Object.defineProperty(Vue.prototype, "locale", {
// 	get() {
// 		return LOCALE;
// 	},
// 	set(val) {
// 		LOCALE = val;
// 		localize(val);
// 	},
// });
